import { nanoid } from "nanoid";

import type { Segment, TranscriptionResponse } from "./types";

export const AUDIO_CONTENT_TYPES = [
  "audio/aac",
  "audio/x-aac",
  "audio/x-aiff",
  "audio/ogg",
  "audio/mpeg",
  "audio/mp3",
  "audio/mpeg3",
  "audio/x-mpeg-3",
  "audio/opus",
  "audio/wav",
  "audio/x-wav",
  "audio/webm",
  "audio/flac",
  "audio/x-flac",
  "audio/mp4",
  "audio/aiff",
  "audio/x-m4a",
];

export const VIDEO_CONTENT_TYPES = [
  "video/mp4",
  "video/x-msvideo",
  "video/x-matroska",
  "video/quicktime",
  "video/x-ms-wmv",
  "video/x-flv",
  "video/webm",
  "video/mpeg",
  "video/3gpp",
];

export const MEDIA_CONTENT_TYPES = [...AUDIO_CONTENT_TYPES, ...VIDEO_CONTENT_TYPES];

export const convertSampleResponseToSegments = (response: TranscriptionResponse): Segment[] => {
  // Convert flat words array into segments
  const segments: Segment[] = [];
  let currentSegment: Segment | null = null;

  // Return empty array if no words available
  if (!response.words) {
    return segments;
  }

  response.words.forEach(word => {
    if (!currentSegment || currentSegment.speaker_id !== word.speaker_id) {
      currentSegment = {
        id: nanoid(),
        speaker_id: word.speaker_id,
        start: word.start,
        end: word.end,
        text: "",
        words: [],
      };
      segments.push(currentSegment);
    }

    currentSegment.words.push({
      ...word,
      id: nanoid(),
      start: word.start,
      end: word.end,
    });
    currentSegment.end = word.end;
    currentSegment.text += word.text;
  });
  return segments;
};

export const urlToFilename = (url: string) => {
  return url.split("/").pop() || "audio.mp3";
};

export const base64ToUint8Array = (base64: string) => {
  const cleaned = base64.replace(/^data:[^;]+;base64,/, "").replace(/\s+/g, "");
  // atob returns a binary string where each char code is a byte
  const binary = atob(cleaned);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};
